export default __webpack_public_path__ + "static/phone-two-hand-hold-4962c45043cc5559fdc0804148c6e3a0.png";